//#region src/variants/variants_rich_text_editor.js
var variants_rich_text_editor_default = { default: { props: {
	modelValue: { initialValue: "<p>The rich text editor allows formatting text with various styles.</p>" },
	inputAriaLabel: { initialValue: "Rich text editor" },
	editable: { initialValue: true },
	placeholder: { initialValue: "Type here..." }
} } };
//#endregion
export { variants_rich_text_editor_default as default };

//# sourceMappingURL=variants_rich_text_editor.js.map